export type LeaderboardRecord = {
	xp: number;
	rank: number;
	username: string;
	avatar: string;
	level: number;
};
